import { useMemo } from "react";

import useApi from "hooks/api";

import {
  buildBalancesRepository,
  buildAccrualsRepository,
  buildCollaboratorAccrualsRepository,
} from "../infrastructure";
import { createUseBalances } from "./useBalances";
import { createUseAccruals } from "./useAccruals";
import { createUseCollaboratorAccruals } from "./useCollaboratorAccruals";

export const useBalances = ({
  typeId,
  colaboraInstanceId,
  page,
  pageSize,
}: {
  typeId: string | undefined;
  colaboraInstanceId?: string;
  page?: number;
  pageSize?: number;
}) => {
  const { genericApiCall } = useApi();

  const balancesRepository = useMemo(
    () => buildBalancesRepository({ apiCaller: genericApiCall }),
    [genericApiCall],
  );

  const useBalancesQuery = useMemo(
    () => createUseBalances({ balancesRepository }),
    [balancesRepository],
  );

  return useBalancesQuery({ typeId, colaboraInstanceId, page, pageSize });
};

export const useAccruals = ({
  colaboraInstanceId,
}: {
  colaboraInstanceId: string;
}) => {
  const { genericApiCall } = useApi();

  const accrualsRepository = useMemo(
    () => buildAccrualsRepository({ apiCaller: genericApiCall }),
    [genericApiCall],
  );

  const useAccrualsQuery = useMemo(
    () => createUseAccruals({ accrualsRepository }),
    [accrualsRepository],
  );

  return useAccrualsQuery({ colaboraInstanceId });
};

export const useCollaboratorAccruals = ({
  collaboratorId,
  colaboraInstanceId,
}: {
  collaboratorId?: string;
  colaboraInstanceId?: string;
}) => {
  const { genericApiCall } = useApi();

  const collaboratorAccrualsRepository = useMemo(
    () => buildCollaboratorAccrualsRepository({ apiCaller: genericApiCall }),
    [genericApiCall],
  );

  const accrualsRepository = useMemo(
    () => buildAccrualsRepository({ apiCaller: genericApiCall }),
    [genericApiCall],
  );

  const useCollaboratorAccrualsQuery = useMemo(
    () =>
      createUseCollaboratorAccruals({
        collaboratorAccrualsRepository,
        accrualsRepository,
      }),
    [collaboratorAccrualsRepository, accrualsRepository],
  );

  return useCollaboratorAccrualsQuery({ collaboratorId, colaboraInstanceId });
};
